<div class="card">
  <img
    [src]="product.image_Name"
    alt="..."
    class="product-image"
    (error)="onImgError($event)"
    (click)="openImageModal(product)"
  />
  <h6 class="card-title">{{ product.item_Name }}</h6>
  <div class="col-12 text-center" *ngIf="!isInCart && isAddToCart">
    <button mat-raised-button (click)="addToCart(product)">Add to cart</button>
  </div>
  <div class="col-12 text-center" *ngIf="isInCart">
    <button mat-raised-button color="primary" (click)="cart()">
      <img
        src="/assets/images/check-out.png"
        alt="Cart Icon"
        class="view-icon"
      />
      View cart
    </button>
  </div>
</div>
